import { Component, CUSTOM_ELEMENTS_SCHEMA, OnDestroy, inject } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { IdleService } from '../../utility/idle.service';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'lib-generic-logout-warning-dialog',
  templateUrl: './generic-logout-warning-dialog.component.html',
  styleUrls: ['./generic-logout-warning-dialog.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [MatDialogModule, RouterModule, MatButtonModule, MatIcon],
})
export class GenericLogoutWarningDialogComponent implements OnDestroy {
  dialogRef = inject<MatDialogRef<GenericLogoutWarningDialogComponent>>(MatDialogRef);
  private idleService = inject(IdleService);

  countdown: string;
  countdownInterval: NodeJS.Timeout;

  
 

  constructor() {
    this.countdown = this.downTimer(this.idleService.secondsUntilTimeOut());
    this.countdownInterval = setInterval(() => {
      if (this.idleService.userHasTimedOut()) {
        this.idleService.onIdleTimeout(true);
        this.dialogRef.close(false);
      } else {
        const secsUntilTimeOut = this.idleService.secondsUntilTimeOut();
        if (secsUntilTimeOut == null) {
          // idle popup was closed with "log out now". No idle information exists. Timeout now
          this.idleService.onIdleTimeout(false);
          this.dialogRef.close(false);
        } else if (secsUntilTimeOut > this.idleService.IDLE_COUNTDOWN_MINS * 60) {
          // idle popup was closed and login refreshed - close this current dialog
          this.dialogRef.close(false);
        } else {
          this.countdown = this.downTimer(secsUntilTimeOut);
        }
      }
    }, 1000);
  }

  ngOnDestroy(): void {
    clearInterval(this.countdownInterval);
  }

  downTimer(seconds: number) {
    const mins = Math.floor(((seconds % 86400) % 3600) / 60);
    const secs = ((seconds % 86400) % 3600) % 60;
    return ('00' + mins).slice(-2) + ':' + ('00' + secs).slice(-2);
  }
}
